(function () {
  'use strict';

  if (window.__stepBundleInit) return;
  window.__stepBundleInit = true;

  var style = document.createElement('style');
  style.textContent =
    // --- Cart banner (full redesign 2 June for 10% / 20% tier structure) ---
    '#step-bundle-banner {' +
      'background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px;' +
      'padding: 18px 20px; margin-bottom: 20px; color: #166534;' +
      'display: flex; flex-direction: column; align-items: center; gap: 12px;' +
      'text-align: center;' +
    '}' +
    '.step-bundle-banner__message { margin: 2px 0; max-width: 460px; }' +
    '.step-bundle-banner__lead {' +
      'font-size: 17px; font-weight: 700; line-height: 1.3;' +
      'margin: 0 0 6px; color: #166534;' +
    '}' +
    '.step-bundle-banner__sub {' +
      'font-size: 14px; font-weight: 400; line-height: 1.5;' +
      'margin: 0; color: #166534;' +
    '}' +
    '.step-bundle-banner__highlight {' +
      'font-style: normal; font-weight: 700; color: #15803d; font-size: inherit;' +
    '}' +
    '.step-bundle-banner__link {' +
      'display: inline-block; margin-top: 4px;' +
      'font-size: 13px; font-weight: 600; color: #166534;' +
      'text-decoration: underline; text-underline-offset: 3px;' +
    '}' +
    '.step-bundle-banner__link:hover { opacity: 0.8; }' +
    '#step-bundle-circles {' +
      'display: flex; align-items: center; justify-content: center; gap: 0;' +
    '}' +
    '.step-bundle-circles__dot {' +
      'display: inline-block; width: 18px; height: 18px; min-width: 18px;' +
      'border-radius: 50%; flex-shrink: 0;' +
    '}' +
    '.step-bundle-circles__dot--filled {' +
      'background-color: #20a64a; border: 2px solid #20a64a;' +
    '}' +
    '.step-bundle-circles__dot--empty {' +
      'background-color: transparent; border: 2px solid #20a64a;' +
    '}' +
    '.step-bundle-circles__line {' +
      'display: inline-block; width: 10px; height: 2px; flex-shrink: 0;' +
      'background-color: #20a64a;' +
    '}' +
    '.step-bundle-circles__label {' +
      'font-size: 13px; color: #166534; font-weight: 500;' +
      'white-space: nowrap; margin-left: 10px;' +
    '}' +
    // Cart drawer placement and overrides
    '#site-cart-sidebar .sidebar__body { display: flex; flex-direction: column; }' +
    '#site-cart-sidebar .sidebar__body > .cart-form { order: 1; }' +
    '#site-cart-sidebar .sidebar__body > #step-bundle-banner { order: 0; }' +
    '#site-cart-sidebar .sidebar__body > .step-cross-sell--cart { order: 3; }' +
    '#site-cart-sidebar .sidebar__body > cart-recommendations { order: 4; }' +
    '#site-cart-sidebar #step-bundle-banner {' +
      'margin: 0 16px 12px; padding: 14px 16px; gap: 10px;' +
    '}' +
    '#site-cart-sidebar .step-bundle-banner__lead { font-size: 16px; }' +
    '#site-cart-sidebar .step-bundle-banner__sub { font-size: 14px; }' +
    '#site-cart-sidebar .step-bundle-banner__link { font-size: 13px; }' +
    '#site-cart-sidebar .step-bundle-circles__dot {' +
      'width: 16px; height: 16px; min-width: 16px;' +
    '}' +
    '#site-cart-sidebar .step-bundle-circles__line { width: 9px; }' +
    '#site-cart-sidebar .step-bundle-circles__label { font-size: 13px; }' +
    '#site-cart-sidebar .sidebar__header { border-bottom: none; padding-bottom: 0.5rem; }' +
    '#site-cart-sidebar .sidebar__body > div.sidebar-large-padding { padding-top: 0.5rem; }' +
    '#site-cart-sidebar .step-cross-sell--cart { margin-bottom: 0; padding-bottom: 16px; }' +
    '#site-cart-sidebar .sidebar__footer { padding: 12px 20px; }' +
    '#site-cart-sidebar .sidebar__footer > shipping-notice { margin: 0 -20px 12px; display: block; }' +
    '#site-cart-sidebar .cart__total strong { font-size: 2.1rem; }' +
    '#site-cart-sidebar .cart__discounts { margin-top: -4px; }' +
    '#site-cart-sidebar .cart__shipping { margin-top: 2px; margin-bottom: 4px; }' +
    '#site-cart-sidebar .wcp-discounts-wrapper { display: none !important; }' +
    '#site-cart-sidebar #wpdNetDiscountCodeWrapper { display: none !important; }' +
    '@media screen and (max-width: 767px) {' +
      '#step-bundle-banner { padding: 14px 16px; gap: 10px; }' +
      '.step-bundle-banner__lead { font-size: 16px; }' +
      '.step-bundle-banner__sub { font-size: 14px; }' +
      '.step-bundle-circles__dot { width: 16px; height: 16px; min-width: 16px; }' +
      '.step-bundle-circles__line { width: 9px; }' +
    '}' +

    // --- Nudge strip ---
    '#step-bundle-nudge {' +
      'background: #f0fdf4; border-bottom: 1px solid #bbf7d0;' +
      'padding: 12px 20px; font-size: 14px; line-height: 1.4; color: #166534;' +
      'display: flex; align-items: center; justify-content: center; gap: 12px;' +
      'flex-wrap: wrap; text-align: center;' +
    '}' +
    '#step-bundle-nudge strong { font-weight: 700; }' +
    '.nudge-circles {' +
      'display: inline-flex; align-items: center; gap: 0; flex-shrink: 0;' +
    '}' +
    '.nudge-circles__dot {' +
      'display: inline-block; width: 16px; height: 16px; min-width: 16px;' +
      'border-radius: 50%; flex-shrink: 0;' +
    '}' +
    '.nudge-circles__dot--filled {' +
      'background-color: #20a64a; border: 2px solid #20a64a;' +
    '}' +
    '.nudge-circles__dot--empty {' +
      'background-color: transparent; border: 2px solid #20a64a;' +
    '}' +
    '.nudge-circles__line {' +
      'display: inline-block; width: 7px; height: 2px; flex-shrink: 0;' +
      'background-color: #20a64a;' +
    '}' +
    '.nudge-cta {' +
      'display: inline-block; font-size: 14px; font-weight: 600;' +
      'text-decoration: none; white-space: nowrap; line-height: 1.4;' +
    '}' +
    '.nudge-cta--shop {' +
      'background: #20a64a; color: #fff; padding: 4px 14px; border-radius: 4px;' +
    '}' +
    '.nudge-cta--shop:hover { background: #1a8f3e; }' +
    '.nudge-cta--checkout {' +
      'background: #20a64a; color: #fff; padding: 4px 14px; border-radius: 4px;' +
    '}' +
    '.nudge-cta--checkout:hover { background: #1a8f3e; }' +
    '.nudge-cta--info {' +
      'color: #166534; text-decoration: none; font-weight: 600;' +
    '}' +
    '.nudge-cta--info:hover { opacity: 0.8; }' +

    // --- Cross-sell shared ---
    '.step-cross-sell {' +
      'background: #fafafa; border: 1px solid #e5e5e5; border-radius: 8px;' +
      'padding: 16px; margin-top: 16px; margin-bottom: 20px;' +
    '}' +
    '.step-cross-sell__heading {' +
      'font-size: 17px; font-weight: 700; color: #166534; margin: 0 0 4px;' +
    '}' +
    '.step-cross-sell__subheading {' +
      'font-size: 14px; color: #555; margin: 0 0 12px; font-weight: 400;' +
    '}' +
    '.step-cross-sell__list {' +
      'display: grid; grid-template-columns: 1fr 1fr; gap: 10px;' +
    '}' +
    '.step-cross-sell__card {' +
      'display: flex; align-items: center; gap: 12px;' +
      'background: #fff; border: 1px solid #e5e5e5; border-radius: 6px;' +
      'padding: 10px; text-decoration: none; color: inherit;' +
    '}' +
    '.step-cross-sell__img {' +
      'width: 70px; height: 70px; object-fit: cover; border-radius: 4px; flex-shrink: 0;' +
    '}' +
    '.step-cross-sell__info {' +
      'flex: 1; min-width: 0;' +
    '}' +
    '.step-cross-sell__title {' +
      'font-size: 13px; font-weight: 500; color: #333; margin: 0;' +
      'display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;' +
      'overflow: hidden; line-height: 1.3;' +
    '}' +
    '.step-cross-sell__meta {' +
      'display: flex; align-items: center; gap: 6px; margin-top: 4px;' +
    '}' +
    '.step-cross-sell__price {' +
      'font-size: 13px; font-weight: 600; color: #333;' +
    '}' +
    '.step-cross-sell__price--compare {' +
      'font-weight: 400; color: #999;' +
    '}' +
    '.step-cross-sell__badge {' +
      'font-size: 11px; font-weight: 500; color: #166534; background: #dcfce7;' +
      'padding: 1px 6px; border-radius: 3px;' +
    '}' +
    '.step-cross-sell__btn {' +
      'flex-shrink: 0; padding: 6px 14px; border-radius: 4px; min-width: 60px;' +
      'font-size: 13px; font-weight: 600; cursor: pointer; text-decoration: none !important;' +
      'border: 1px solid #20a64a; background: #20a64a !important; color: #fff !important;' +
      'line-height: 1.4; text-align: center; display: inline-block; box-sizing: border-box;' +
    '}' +
    '.step-cross-sell__btn:hover { background: #1a8f3e !important; border-color: #1a8f3e; color: #fff !important; }' +
    '.step-cross-sell__btn--view {' +
      'background: transparent !important; color: #20a64a !important;' +
    '}' +
    '.step-cross-sell__btn--view:hover { background: #f0fdf4 !important; color: #20a64a !important; }' +
    '.step-cross-sell__btn:disabled {' +
      'opacity: 0.6; cursor: not-allowed;' +
    '}' +

    // --- Step group (PDP grouped-by-step layout) ---
    '.step-cross-sell__group { margin-bottom: 14px; }' +
    '.step-cross-sell__group:last-child { margin-bottom: 0; }' +
    '.step-cross-sell__group-label {' +
      'font-size: 12px; font-weight: 600; color: #166534; text-transform: uppercase;' +
      'letter-spacing: 0.5px; margin: 0 0 8px;' +
    '}' +
    '.step-cross-sell__see-all {' +
      'display: block; text-align: right; font-size: 12px; color: #20a64a;' +
      'font-weight: 500; text-decoration: none; margin-top: 6px;' +
    '}' +
    '.step-cross-sell__see-all:hover { text-decoration: underline; }' +

    // --- Cart page "See all" collection links ---
    '.step-cross-sell__browse {' +
      'display: flex; flex-wrap: wrap; gap: 4px 16px; margin-top: 10px;' +
    '}' +
    '.step-cross-sell__browse-link {' +
      'font-size: 13px; color: #20a64a; font-weight: 500; text-decoration: none;' +
    '}' +
    '.step-cross-sell__browse-link:hover { text-decoration: underline; }' +
    '.step-cross-sell__info-link {' +
      'color: #20a64a; font-weight: 600; text-decoration: none; font-size: 13px; white-space: nowrap; margin-left: 6px; vertical-align: baseline;' +
    '}' +
    '.step-cross-sell__info-link:hover { text-decoration: underline; }' +

    // --- Drawer overrides ---
    '#site-cart-sidebar .step-cross-sell__list { grid-template-columns: 1fr; }' +
    '#site-cart-sidebar .step-cross-sell {' +
      'margin: 0 20px 16px; border-radius: 6px; padding: 12px;' +
    '}' +
    '#site-cart-sidebar .step-cross-sell__img {' +
      'width: 56px; height: 56px;' +
    '}' +
    '#site-cart-sidebar .step-cross-sell__card { padding: 8px; gap: 10px; }' +
    '#site-cart-sidebar .step-cross-sell__btn { padding: 5px 10px; font-size: 12px; }' +

    // --- PDP cross-sell ---
    '.step-pdp-cross-sell { margin-top: 16px; }' +
    '.step-pdp-cross-sell .step-cross-sell__list {' +
      'display: grid; grid-template-columns: 1fr 1fr; gap: 8px;' +
    '}' +
    '.step-pdp-cross-sell .step-cross-sell__card {' +
      'position: relative; overflow: hidden; cursor: pointer;' +
      'flex-direction: column; text-align: center; padding: 10px 8px; gap: 8px;' +
    '}' +
    '.step-pdp-cross-sell .step-cross-sell__img {' +
      'width: 80px; height: 80px; margin: 0 auto;' +
    '}' +
    '.step-pdp-cross-sell .step-cross-sell__info { text-align: center; }' +
    '.step-pdp-cross-sell .step-cross-sell__meta { justify-content: center; }' +

    // --- PDP corner triangles ---
    '.step-cross-sell__corner {' +
      'position: absolute; width: 0; height: 0; z-index: 1; pointer-events: auto;' +
    '}' +
    '.step-cross-sell__corner-label {' +
      'position: absolute; font-size: 12px; font-weight: 700; white-space: nowrap;' +
      'pointer-events: none;' +
    '}' +
    '.step-cross-sell__corner--add {' +
      'top: 0; right: 0; cursor: pointer;' +
      'border-top: 64px solid #20a64a; border-left: 64px solid transparent;' +
      'transition: border-top-width 0.25s ease, border-left-width 0.25s ease, border-top-color 0.25s ease;' +
    '}' +
    '.step-cross-sell__corner--add .step-cross-sell__corner-label {' +
      'color: #fff; top: -56px; right: 8px;' +
      'transition: top 0.25s ease, right 0.25s ease, font-size 0.25s ease;' +
    '}' +
    '.step-cross-sell__corner--view {' +
      'top: 0; left: 0;' +
      'border-top: 64px solid #dcfce7; border-right: 64px solid transparent;' +
      'transition: border-top-width 0.25s ease, border-right-width 0.25s ease, border-top-color 0.25s ease;' +
    '}' +
    '.step-cross-sell__corner--view .step-cross-sell__corner-label {' +
      'color: #166534; top: -56px; left: 9px;' +
      'transition: top 0.25s ease, left 0.25s ease, font-size 0.25s ease;' +
    '}' +
    '.step-cross-sell__corner--view:hover {' +
      'border-top-width: 76px; border-right-width: 76px; border-top-color: #bbf7d0;' +
    '}' +
    '.step-cross-sell__corner--view:hover .step-cross-sell__corner-label {' +
      'top: -66px; left: 11px; font-size: 13px;' +
    '}' +
    '.step-pdp-cross-sell .step-cross-sell__card--add { cursor: pointer; }' +
    '.step-pdp-cross-sell .step-cross-sell__card--add:hover:not(:has(.step-cross-sell__corner--view:hover)) .step-cross-sell__corner--add {' +
      'border-top-width: 76px; border-left-width: 76px; border-top-color: #1d1d1d;' +
    '}' +
    '.step-pdp-cross-sell .step-cross-sell__card--add:hover:not(:has(.step-cross-sell__corner--view:hover)) .step-cross-sell__corner--add .step-cross-sell__corner-label {' +
      'top: -66px; right: 10px; font-size: 13px;' +
    '}' +
    '.step-pdp-cross-sell .step-cross-sell__card--view-only:hover .step-cross-sell__corner--view {' +
      'border-top-width: 76px; border-right-width: 76px; border-top-color: #bbf7d0;' +
    '}' +
    '.step-pdp-cross-sell .step-cross-sell__card--view-only:hover .step-cross-sell__corner--view .step-cross-sell__corner-label {' +
      'top: -66px; left: 11px; font-size: 13px;' +
    '}' +

    // --- Cart page shipping notice ---
    '.cart-section shipping-notice [class*="alert"] {' +
      'background: #166534; color: #fff; font-weight: 600; border: none;' +
    '}' +

    // --- Savings line in totals card ---
    '.step-bundle-savings {' +
      'display: flex; justify-content: space-between; align-items: center;' +
      'padding: 8px 0; font-size: 14px; color: #166534;' +
      'border-top: 1px dashed #bbf7d0; margin-top: 4px;' +
    '}' +
    '.step-bundle-savings__label { font-weight: 500; }' +
    '.step-bundle-savings__amount { font-weight: 700; font-size: 16px; }' +
    '.step-bundle-savings--total { border-top: none; margin-top: 0; padding-top: 0; color: #1a1a1a; }' +
    '.step-bundle-savings--total .step-bundle-savings__label { font-weight: 700; }' +
    '.step-bundle-savings--total .step-bundle-savings__amount { font-size: 18px; }' +
    '@keyframes stepSpinner { to { transform: rotate(360deg); } }' +
    '.step-cross-sell__corner-spinner {' +
      'display: inline-block; width: 14px; height: 14px;' +
      'border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff;' +
      'border-radius: 50%; animation: stepSpinner 0.6s linear infinite;' +
    '}' +

    // --- Mobile ---
    '@media screen and (max-width: 767px) {' +
      '#step-bundle-nudge { font-size: 13px; padding: 12px 12px; gap: 8px; }' +
      '.step-cross-sell__list { grid-template-columns: 1fr; }' +
      '.step-cross-sell__img { width: 56px; height: 56px; }' +
      '.step-cross-sell__btn { padding: 5px 10px; font-size: 12px; }' +
    '}';
  document.head.appendChild(style);

  var WORKER_URL = 'https://step-bundle-worker-v2.admin3027.workers.dev';
  var VALID_STEPS = { 1: true, 2: true, 3: true, 4: true };
  var STORAGE_KEY = 'stepBundleDiscount';

  function getStepData() {
    var el = document.getElementById('step-bundle-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getUniqueSteps(data) {
    var uniqueSteps = {};
    if (!data || !data.items) return uniqueSteps;

    for (var i = 0; i < data.items.length; i++) {
      var steps = data.items[i].steps;
      if (!Array.isArray(steps)) continue;
      for (var j = 0; j < steps.length; j++) {
        var s = String(steps[j]);
        if (VALID_STEPS[s]) uniqueSteps[s] = true;
      }
    }
    return uniqueSteps;
  }

  function computeTier(data) {
    if (!data || !data.items || data.items.length === 0) return null;

    var uniqueSteps = getUniqueSteps(data);
    var stepProductIds = [];

    for (var i = 0; i < data.items.length; i++) {
      var item = data.items[i];
      var steps = item.steps;
      if (!Array.isArray(steps) || steps.length === 0) continue;

      var isStepProduct = false;
      for (var j = 0; j < steps.length; j++) {
        if (VALID_STEPS[String(steps[j])]) isStepProduct = true;
      }
      if (isStepProduct) {
        stepProductIds.push(String(item.product_id));
      }
    }

    if (!uniqueSteps['1'] || !uniqueSteps['2']) return null;

    var count = Object.keys(uniqueSteps).length;
    var percent, tier;

    if (count >= 4) { percent = 20; tier = 4; }
    else { percent = 10; tier = 2; }

    return { percent: percent, tier: tier, stepProductIds: stepProductIds };
  }

  function buildCirclesHTML(uniqueSteps) {
    var html = '';
    for (var i = 1; i <= 4; i++) {
      var filled = uniqueSteps[String(i)];
      html += '<span class="step-bundle-circles__dot step-bundle-circles__dot--' +
        (filled ? 'filled' : 'empty') + '" aria-hidden="true"></span>';
      if (i < 4) {
        html += '<span class="step-bundle-circles__line" aria-hidden="true"></span>';
      }
    }

    var filledSteps = Object.keys(uniqueSteps).sort();
    var label = '';
    if (filledSteps.length === 1) {
      label = 'Step ' + filledSteps[0] + ' in cart';
    } else if (filledSteps.length > 1) {
      var last = filledSteps.pop();
      label = 'Steps ' + filledSteps.join(', ') + ' & ' + last + ' in cart';
    }
    // length === 0: deliberately empty — banner is hidden on empty cart anyway

    var labelHtml = label
      ? '<span class="step-bundle-circles__label">' + label + '</span>'
      : '';
    var ariaLabel = label || 'No steps in cart';

    return '<div id="step-bundle-circles" role="img" aria-label="' + ariaLabel + '">' +
      html +
      labelHtml +
    '</div>';
  }

  function isCartPage() {
    return document.querySelector('.cart-section') !== null;
  }

  // --- Cross-sell utilities ---

  function getCrossSellData() {
    var el = document.getElementById('step-cross-sell-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getCartProductIds(data) {
    var ids = {};
    if (!data || !data.items) return ids;
    for (var i = 0; i < data.items.length; i++) {
      ids[String(data.items[i].product_id)] = true;
    }
    return ids;
  }

  function getMissingSteps(uniqueSteps) {
    var missing = [];
    for (var i = 1; i <= 4; i++) {
      if (!uniqueSteps[String(i)]) missing.push(String(i));
    }
    return missing;
  }

  function getFilteredProducts(crossSellData, step, cartProductIds, currentProductId, max) {
    var results = [];
    var products = crossSellData[step];
    if (!products) return results;
    for (var j = 0; j < products.length; j++) {
      if (results.length >= max) break;
      var p = products[j];
      if (cartProductIds[String(p.id)]) continue;
      if (currentProductId && String(p.id) === String(currentProductId)) continue;
      var copy = {};
      for (var k in p) { if (p.hasOwnProperty(k)) copy[k] = p[k]; }
      copy._step = step;
      results.push(copy);
    }
    return results;
  }

  function getCrossSellProducts(crossSellData, missingSteps, cartProductIds, currentProductId, maxPerStep, maxTotal) {
    var results = [];
    if (!crossSellData) return results;

    for (var i = 0; i < missingSteps.length; i++) {
      var step = missingSteps[i];
      var stepProducts = getFilteredProducts(crossSellData, step, cartProductIds, currentProductId, maxPerStep);
      for (var j = 0; j < stepProducts.length; j++) {
        if (results.length >= maxTotal) break;
        results.push(stepProducts[j]);
      }
    }
    return results;
  }

  function getCurrentProductId() {
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return String(window.ShopifyAnalytics.meta.product.id);
    }
    var idMeta = document.querySelector('[data-product-id]');
    if (idMeta) return idMeta.getAttribute('data-product-id');
    return null;
  }

  function getCurrentProductSteps() {
    var wrapper = document.querySelector('.step-circles');
    if (!wrapper) return [];
    var allDots = wrapper.querySelectorAll('.step-circles__dot');
    var steps = [];
    for (var i = 0; i < allDots.length; i++) {
      if (allDots[i].classList.contains('step-circles__dot--filled')) {
        steps.push(String(i + 1));
      }
    }
    return steps;
  }

  function getNudgeMessage(uniqueSteps, stepCount) {
    var has1 = !!uniqueSteps['1'];
    var has2 = !!uniqueSteps['2'];

    if (stepCount === 0) return '';

    if (stepCount >= 4) {
      return "Full routine, maximum saving &mdash; <strong>20% off your step products.</strong>";
    }

    if (has1 && has2) {
      if (stepCount === 3) {
        var missing = uniqueSteps['3'] ? '4' : '3';
        return "Strong routine &mdash; add Step " + missing + " to unlock <strong>20% off.</strong>";
      }
      return "You're protected &mdash; complete all 4 steps to unlock <strong>20% off.</strong>";
    }

    if (has1 && !has2) {
      return "Great start &mdash; add Step 2 for clinically proven repellent protection. <strong>You'll save 10%.</strong>";
    }
    if (has2 && !has1) {
      return "You've got the repellent &mdash; add Step 1 to prepare your skin and <strong>save 10%.</strong>";
    }

    // Only 3 and/or 4
    return "Start with the essentials &mdash; add Steps 1 &amp; 2 for the foundation of your routine. <strong>Save 10%.</strong>";
  }

  function getNudgeCTA(uniqueSteps) {
    var has1 = !!uniqueSteps['1'];
    var has2 = !!uniqueSteps['2'];

    // Qualifying (1+2 in cart) — show checkout link
    if (has1 && has2) {
      return '<a href="/cart" class="nudge-cta nudge-cta--checkout">View cart &rarr;</a>';
    }

    // Not qualifying — link to the most impactful missing step collection
    var targetStep;
    if (!has1 && !has2) {
      targetStep = '1';
    } else if (has1) {
      targetStep = '2';
    } else {
      targetStep = '1';
    }
    return '<a href="/collections/step-' + targetStep + '-products" class="nudge-cta nudge-cta--shop">Shop Step ' + targetStep + '</a>';
  }

  function buildMiniCirclesHTML(uniqueSteps) {
    var html = '<span class="nudge-circles">';
    for (var i = 1; i <= 4; i++) {
      var filled = uniqueSteps[String(i)];
      html += '<span class="nudge-circles__dot nudge-circles__dot--' +
        (filled ? 'filled' : 'empty') + '"></span>';
      if (i < 4) {
        html += '<span class="nudge-circles__line"></span>';
      }
    }
    html += '</span>';
    return html;
  }

  function cardInfoHTML(item) {
    return '<div class="step-cross-sell__info">' +
      '<p class="step-cross-sell__title">' + item.title + '</p>' +
      '<div class="step-cross-sell__meta">' +
        (item.compare_at_price_formatted ? '<span class="step-cross-sell__price step-cross-sell__price--compare"><s>' + item.compare_at_price_formatted + '</s></span>' : '') +
        '<span class="step-cross-sell__price">' + item.price_formatted + '</span>' +
        '<span class="step-cross-sell__badge">Step ' + item._step + '</span>' +
      '</div>' +
    '</div>';
  }

  function buildPDPCardHTML(item) {
    if (item.has_only_default_variant) {
      var corners = '<a href="' + item.url + '" class="step-cross-sell__corner step-cross-sell__corner--view">' +
        '<span class="step-cross-sell__corner-label">View</span></a>' +
        '<span class="step-cross-sell__corner step-cross-sell__corner--add" data-variant-id="' + item.variant_id + '">' +
        '<span class="step-cross-sell__corner-label">Add</span></span>';
      return '<div class="step-cross-sell__card step-cross-sell__card--add" data-variant-id="' + item.variant_id + '">' +
        corners +
        '<img class="step-cross-sell__img" src="' + item.image + '" alt="" loading="lazy">' +
        cardInfoHTML(item) +
      '</div>';
    }
    return '<a href="' + item.url + '" class="step-cross-sell__card step-cross-sell__card--view-only">' +
      '<span class="step-cross-sell__corner step-cross-sell__corner--view">' +
        '<span class="step-cross-sell__corner-label">View</span></span>' +
      '<img class="step-cross-sell__img" src="' + item.image + '" alt="" loading="lazy">' +
      cardInfoHTML(item) +
    '</a>';
  }

  function buildCartCardHTML(item) {
    var btnHTML;
    if (item.has_only_default_variant) {
      btnHTML = '<button class="step-cross-sell__btn" data-variant-id="' + item.variant_id + '">Add</button>';
    } else {
      btnHTML = '<span class="step-cross-sell__btn step-cross-sell__btn--view">View</span>';
    }
    return '<a href="' + item.url + '" class="step-cross-sell__card">' +
      '<img class="step-cross-sell__img" src="' + item.image + '" alt="" loading="lazy">' +
      cardInfoHTML(item) +
      btnHTML +
    '</a>';
  }

  function buildDrawerCardHTML(item) {
    return '<div class="step-cross-sell__card">' +
      '<img class="step-cross-sell__img" src="' + item.image + '" alt="" loading="lazy">' +
      cardInfoHTML(item) +
      '<button class="step-cross-sell__btn" data-variant-id="' + item.variant_id + '">Add</button>' +
    '</div>';
  }

  function ajaxAddToCart(variantId, button) {
    button.disabled = true;
    button.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (resp) {
      if (!resp.ok) throw new Error('Add failed');
      return resp.json();
    })
    .then(function () {
      button.textContent = 'Added!';
      if (isCartPage()) {
        window.location.reload();
      } else if (typeof window.refreshCart === 'function') {
        window.refreshCart();
        setTimeout(function () {
          var sidebar = document.getElementById('site-cart-sidebar');
          if (sidebar) sidebar.scrollTop = 0;
          var body = sidebar && sidebar.querySelector('.sidebar__body');
          if (body) body.scrollTop = 0;
        }, 600);
      } else {
        window.location.reload();
      }
    })
    .catch(function () {
      button.disabled = false;
      button.style.pointerEvents = '';
      button.textContent = 'Add';
    });
  }

  function attachCrossSellListeners(container) {
    // Inline Add buttons (cart page + drawer)
    var buttons = container.querySelectorAll('.step-cross-sell__btn[data-variant-id]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var vid = this.getAttribute('data-variant-id');
        if (vid) ajaxAddToCart(Number(vid), this);
      });
    }

    // PDP card-level Add (whole card is clickable to add)
    var addCards = container.querySelectorAll('.step-cross-sell__card--add[data-variant-id]');
    for (var j = 0; j < addCards.length; j++) {
      addCards[j].style.cursor = 'pointer';
      addCards[j].addEventListener('click', function (e) {
        // Let the View corner link handle its own navigation
        if (e.target.closest('.step-cross-sell__corner--view')) return;
        e.preventDefault();
        e.stopPropagation();
        var vid = this.getAttribute('data-variant-id');
        if (vid) {
          var card = this;
          var addLabel = card.querySelector('.step-cross-sell__corner--add .step-cross-sell__corner-label');
          if (addLabel) {
            var spinner = document.createElement('span');
            spinner.className = 'step-cross-sell__corner-spinner';
            addLabel.textContent = '';
            addLabel.appendChild(spinner);
          }
          card.style.pointerEvents = 'none';
          ajaxAddToCart(Number(vid), {
            set disabled(v) {},
            get disabled() { return false; },
            set textContent(t) {
              if (!addLabel) return;
              if (t === 'Added!') {
                addLabel.textContent = '\u2713';
              } else if (t === 'Add') {
                addLabel.textContent = 'Add';
                card.style.pointerEvents = '';
              }
            },
            get textContent() { return addLabel ? addLabel.textContent : ''; },
            style: card.style
          });
        }
      });
    }
  }

  // --- Savings line ---

  function formatMoney(cents) {
    var totalEl = document.querySelector('.cart__total strong');
    var symbol = '\u00a3';
    if (totalEl) {
      var text = totalEl.textContent.trim();
      var match = text.match(/^([^\d\s]*)/);
      if (match && match[1]) symbol = match[1];
    }
    return symbol + (Math.round(cents) / 100).toFixed(2);
  }

  function renderSavingsLine(data, tier) {
    var existing = document.querySelectorAll('.step-bundle-savings');
    for (var i = 0; i < existing.length; i++) existing[i].remove();

    if (!tier || !data || !data.items) return;

    // Work out what checkout will charge. Shopify applies only the better of the
    // Step System code and any automatic discount (e.g. Upsell Kit) on each line.
    var afterTotal = 0;
    for (var i = 0; i < data.items.length; i++) {
      var item = data.items[i];
      var original = item.line_price || 0;
      var finalLine = typeof item.final_line_price === 'number' ? item.final_line_price : original;
      var steps = item.steps;
      var isStep = false;
      if (Array.isArray(steps)) {
        for (var j = 0; j < steps.length; j++) {
          if (VALID_STEPS[String(steps[j])]) isStep = true;
        }
      }
      if (!isStep || !item.price) {
        afterTotal += finalLine;
        continue;
      }
      // Match Shopify's per-unit floor rounding
      var stepDiscount = Math.floor(item.price * tier.percent / 100) * (item.quantity || 1);
      afterTotal += original - Math.max(stepDiscount, original - finalLine);
    }

    var shownTotal = typeof data.total_price === 'number' ? data.total_price : afterTotal;
    var savings = shownTotal - afterTotal;
    if (savings <= 0) return;

    var containers = document.querySelectorAll('.cart__details');
    for (var c = 0; c < containers.length; c++) {
      var total = containers[c].querySelector('.cart__total');
      var shipping = containers[c].querySelector('.cart__shipping');
      if (!total) continue;

      var el = document.createElement('div');
      el.className = 'step-bundle-savings';
      el.innerHTML =
        '<span class="step-bundle-savings__label">Step System saving (' + tier.percent + '%)</span>' +
        '<span class="step-bundle-savings__amount">&minus;' + formatMoney(savings) + '</span>';

      if (shipping) {
        containers[c].insertBefore(el, shipping);
      } else {
        total.parentNode.insertBefore(el, total.nextSibling);
      }

      // The saving only comes off at checkout, so show what the customer will pay
      if (typeof data.total_price === 'number') {
        var totalEl = document.createElement('div');
        totalEl.className = 'step-bundle-savings step-bundle-savings--total';
        totalEl.innerHTML =
          '<span class="step-bundle-savings__label">Total after saving</span>' +
          '<span class="step-bundle-savings__amount">' + formatMoney(afterTotal) + '</span>';
        el.parentNode.insertBefore(totalEl, el.nextSibling);
      }
    }
  }

  // --- Discount tracking ---

  function saveAppliedCode(code, tier) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ code: code, tier: tier }));
    } catch (e) {}
  }

  function getAppliedCode() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function clearAppliedCode() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function clearStaleDiscount(currentTier) {
    var stored = getAppliedCode();
    if (!stored) return;

    var newTierValue = currentTier ? currentTier.tier : 0;
    if (stored.tier === newTierValue) return;

    clearAppliedCode();

    // localStorage (not sessionStorage) so a code applied in one tab is still
    // cleared when the cart changes in another tab.
    fetch(WORKER_URL + '/api/discount/clear', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: stored.code }),
    }).catch(function () {});

    // Deleting the code alone leaves it applied to the cart until the cart is
    // re-priced, so take it off the cart directly and keep any other codes.
    removeCodeFromCart(stored.code)
      .then(function (removed) {
        if (!removed) return;
        if (isCartPage()) {
          window.location.reload();
        } else if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        }
      })
      .catch(function () {});

    fetch('/discount/', { redirect: 'manual', credentials: 'same-origin' }).catch(function () {});
  }

  function removeCodeFromCart(code) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (resp) { return resp.json(); })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        var found = false;
        var keep = [];
        for (var i = 0; i < codes.length; i++) {
          if (String(codes[i].code).toLowerCase() === String(code).toLowerCase()) {
            found = true;
          } else {
            keep.push(codes[i].code);
          }
        }
        if (!found) return false;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: keep.join(',') }),
        }).then(function () { return true; });
      });
  }

  // --- UI ---

  function getBannerContent(data, tier) {
    var uniqueSteps = getUniqueSteps(data);
    var stepCount = Object.keys(uniqueSteps).length;
    var has1 = !!uniqueSteps['1'];
    var has2 = !!uniqueSteps['2'];

    // Emphasis helper — class-based, NOT <strong>, so theme CSS can't bump font-size.
    var H = function (text) {
      return '<em class="step-bundle-banner__highlight">' + text + '</em>';
    };

    // "Find out more" anchors to the relevant step section on the SSS page
    // (per Kim's 21 May email).
    var buildInfoLink = function (anchorStep) {
      var href = '/pages/incognito-simple-step-system';
      if (anchorStep) href += '#step-' + anchorStep;
      return '<a href="' + href + '" class="step-bundle-banner__link">Find out more &rarr;</a>';
    };

    var lead, sub;
    var link = '';

    if (tier && tier.tier === 4) {
      lead = 'You’re saving ' + H('20%');
      sub = 'Applied automatically at checkout.';
    } else if (tier && stepCount === 3) {
      var missing = uniqueSteps['3'] ? '4' : '3';
      lead = 'You’re saving ' + H('10%');
      sub = 'Add ' + H('Step ' + missing) + ' to unlock ' + H('20% off') + '.';
    } else if (tier) {
      lead = 'You’re saving ' + H('10%');
      sub = 'Complete all 4 steps to unlock ' + H('20% off') + '.';
    } else if (stepCount === 0) {
      lead = 'Build your protection routine';
      sub = 'The more steps you add, the more you save.';
      link = buildInfoLink(1);
    } else if (has1 && !has2) {
      lead = 'Great start';
      sub = 'Add ' + H('Step 2') + ' for proven repellent protection and save ' + H('10%') + '.';
      link = buildInfoLink(2);
    } else if (has2 && !has1) {
      lead = 'You’ve got the repellent';
      sub = 'Add ' + H('Step 1') + ' to prepare your skin and save ' + H('10%') + '.';
      link = buildInfoLink(1);
    } else {
      // Only step 3 and/or 4 in cart — needs to add 1 + 2.
      lead = 'Start with the essentials';
      sub = 'Add ' + H('Steps 1 + 2') + ' together to unlock ' + H('10% off') + '.';
      link = buildInfoLink(1);
    }

    return buildCirclesHTML(uniqueSteps) +
      '<div class="step-bundle-banner__message">' +
        '<p class="step-bundle-banner__lead">' + lead + '</p>' +
        '<p class="step-bundle-banner__sub">' + sub + '</p>' +
      '</div>' +
      link;
  }

  function renderUI(data, tier) {
    var existing = document.getElementById('step-bundle-banner');
    if (existing) existing.remove();

    // Don't render the banner when cart is truly empty — no value in nudging
    // alongside the "your cart is empty" message. Avoids the broken state where
    // the circles label rendered "Steps & undefined in cart".
    if (!data || !data.items || data.items.length === 0) return;

    // Only render in cart contexts (cart page or drawer)
    var onCartPage = isCartPage();
    var sidebarBody = document.querySelector('#site-cart-sidebar .sidebar__body');
    if (!onCartPage && !sidebarBody) return;

    var banner = document.createElement('div');
    banner.id = 'step-bundle-banner';
    banner.setAttribute('role', 'status');
    banner.innerHTML = getBannerContent(data, tier);

    if (onCartPage) {
      var cartForm = document.querySelector('cart-form, form#cart, .cart-section');
      if (cartForm) {
        cartForm.parentNode.insertBefore(banner, cartForm);
      }
    } else if (sidebarBody) {
      var cartFormDiv = sidebarBody.querySelector('.cart-form');
      if (cartFormDiv && cartFormDiv.nextSibling) {
        sidebarBody.insertBefore(banner, cartFormDiv.nextSibling);
      } else if (cartFormDiv) {
        sidebarBody.appendChild(banner);
      } else {
        sidebarBody.insertBefore(banner, sidebarBody.firstChild);
      }
      reorderSidebarShipping(sidebarBody);
    }
  }

  function reorderSidebarShipping(sidebarBody) {
    var sidebar = document.getElementById('site-cart-sidebar');
    if (!sidebar) return;
    var footer = sidebar.querySelector('.sidebar__footer');
    if (!footer) return;

    var bodyShipping = sidebarBody.querySelector('shipping-notice');
    var footerShipping = footer.querySelector('shipping-notice');

    if (bodyShipping) {
      // New one rendered in body — remove old from footer if present, then move new one
      if (footerShipping) footerShipping.remove();
      footer.insertBefore(bodyShipping, footer.firstChild);
    }
    // If no bodyShipping but footerShipping exists, leave it alone (already moved)
  }

  function removeUI() {
    var banner = document.getElementById('step-bundle-banner');
    if (banner) banner.remove();
  }

  // --- Nudge strip ---

  function renderNudgeStrip(data) {
    var nudge = document.getElementById('step-bundle-nudge');
    if (!nudge) return;

    if (isCartPage()) {
      nudge.style.display = 'none';
      nudge.innerHTML = '';
      return;
    }

    var uniqueSteps = getUniqueSteps(data);
    var stepCount = Object.keys(uniqueSteps).length;

    if (stepCount === 0) {
      var emptyCircles = buildMiniCirclesHTML({});
      nudge.textContent = '';
      var frag = document.createDocumentFragment();
      var circlesWrap = document.createElement('span');
      circlesWrap.className = 'nudge-circles';
      for (var s = 1; s <= 4; s++) {
        var dot = document.createElement('span');
        dot.className = 'nudge-circles__dot nudge-circles__dot--empty';
        circlesWrap.appendChild(dot);
        if (s < 4) {
          var line = document.createElement('span');
          line.className = 'nudge-circles__line';
          circlesWrap.appendChild(line);
        }
      }
      frag.appendChild(circlesWrap);
      var msg = document.createElement('span');
      msg.appendChild(document.createTextNode('Layer your protection with the incognito\u00AE Simple Step System. '));
      var bold = document.createElement('strong');
      bold.textContent = 'The more steps, the more you save.';
      msg.appendChild(bold);
      frag.appendChild(msg);
      if (window.location.pathname !== '/pages/incognito-simple-step-system') {
        var link = document.createElement('a');
        link.href = '/pages/incognito-simple-step-system';
        link.className = 'nudge-cta nudge-cta--shop';
        link.textContent = 'Find out more';
        frag.appendChild(link);
      }
      nudge.appendChild(frag);
      nudge.style.display = '';
      return;
    }

    var message = getNudgeMessage(uniqueSteps, stepCount);
    var cta = getNudgeCTA(uniqueSteps);
    nudge.innerHTML =
      buildMiniCirclesHTML(uniqueSteps) +
      '<span>' + message + '</span>' +
      cta +
      (window.location.pathname !== '/pages/incognito-simple-step-system' ? '<a href="/pages/incognito-simple-step-system" class="nudge-cta nudge-cta--info">Find out more &rarr;</a>' : '');
    nudge.style.display = '';
  }

  // --- Cart cross-sell ---

  function renderCartCrossSell(data) {
    var existing = document.querySelectorAll('.step-cross-sell--cart');
    for (var i = 0; i < existing.length; i++) existing[i].remove();

    // Skip cross-sell entirely if cart is truly empty (no items at all).
    if (!data || !data.items || data.items.length === 0) return;

    var uniqueSteps = getUniqueSteps(data);
    var stepCount = Object.keys(uniqueSteps).length;
    var has1 = !!uniqueSteps['1'];
    var has2 = !!uniqueSteps['2'];
    var has3 = !!uniqueSteps['3'];
    var has4 = !!uniqueSteps['4'];

    var onCartPage = isCartPage();
    var html = '';

    if (stepCount === 4) {
      html = '<div class="step-cross-sell step-cross-sell--cart step-cross-sell--complete">' +
        '<p class="step-cross-sell__heading">You’re all set. Your 20% off applies automatically at checkout.</p>' +
      '</div>';
    } else {
      // Decide which step pool(s) to draw cross-sell products from, per Kim's
      // 21 May rule: never reveal Step 3 or 4 before Steps 1 + 2 are in cart.
      var targetSteps = [];
      var heading = 'Boost your protection.';

      if (stepCount === 0) {
        // Cart has items but no qualifying steps — show Step 1 + 2 essentials.
        targetSteps = ['1', '2'];
        heading = 'Start your protection routine';
      } else if (has1 && !has2) {
        // Step 1 in cart — fill cross-sell with Step 2 products.
        targetSteps = ['2'];
      } else if (has2 && !has1) {
        // Step 2 in cart — fill cross-sell with Step 1 products (mirror).
        targetSteps = ['1'];
      } else if (has1 && has2 && !has3 && !has4) {
        // Both essentials in — mix Step 3 + 4.
        targetSteps = ['3', '4'];
      } else if (has1 && has2 && has3 && !has4) {
        // 1+2+3 — narrow to Step 4 only.
        targetSteps = ['4'];
        heading = 'Complete your routine';
      } else if (has1 && has2 && !has3 && has4) {
        // 1+2+4 — narrow to Step 3 only.
        targetSteps = ['3'];
        heading = 'Complete your routine';
      } else {
        // Only Step 3 and/or 4 in cart, no Step 1 or 2. Show the missing
        // essentials so the customer can complete the foundation tier.
        targetSteps = ['1', '2'];
        heading = 'Start your protection routine';
      }

      var crossSellData = getCrossSellData();
      if (!crossSellData) return;

      var cartProductIds = getCartProductIds(data);
      var maxTotal = 4;
      var maxPerStep = targetSteps.length === 1
        ? maxTotal
        : Math.ceil(maxTotal / targetSteps.length);
      var products = getCrossSellProducts(crossSellData, targetSteps, cartProductIds, null, maxPerStep, maxTotal);
      if (products.length === 0) return;

      // Drawer: filter out multi-variant products
      if (!onCartPage) {
        var filtered = [];
        for (var f = 0; f < products.length; f++) {
          if (products[f].has_only_default_variant) filtered.push(products[f]);
        }
        products = filtered;
        if (products.length === 0) return;
      }

      html = '<div class="step-cross-sell step-cross-sell--cart">' +
        '<p class="step-cross-sell__heading">' + heading + '</p>' +
        '<div class="step-cross-sell__list">';
      for (var j = 0; j < products.length; j++) {
        html += onCartPage ? buildCartCardHTML(products[j]) : buildDrawerCardHTML(products[j]);
      }
      html += '</div>';

      // Cart page only: "See all" collection links per targeted step
      if (onCartPage) {
        html += '<div class="step-cross-sell__browse">';
        for (var l = 0; l < targetSteps.length; l++) {
          html += '<a href="/collections/step-' + targetSteps[l] + '-products" class="step-cross-sell__browse-link">See all Step ' + targetSteps[l] + ' products &rarr;</a>';
        }
        html += '</div>';
      }

      html += '</div>';
    }

    // --- Insert into cart (page or drawer) ---
    if (onCartPage) {
      var banner = document.getElementById('step-bundle-banner');
      var cartForm = document.querySelector('cart-form, form#cart, .cart-section');
      var container = document.createElement('div');
      container.innerHTML = html;
      var crossSell = container.firstChild;

      if (banner && banner.nextSibling) {
        banner.parentNode.insertBefore(crossSell, banner.nextSibling);
      } else if (cartForm) {
        cartForm.parentNode.insertBefore(crossSell, cartForm);
      }
      attachCrossSellListeners(crossSell);
    } else {
      var sidebarBody = document.querySelector('#site-cart-sidebar .sidebar__body');
      if (sidebarBody) {
        var sidebarBanner = sidebarBody.querySelector('#step-bundle-banner');
        var cartFormDiv = sidebarBody.querySelector('.cart-form');
        var container2 = document.createElement('div');
        container2.innerHTML = html;
        var crossSell2 = container2.firstChild;

        if (sidebarBanner && sidebarBanner.nextSibling) {
          sidebarBody.insertBefore(crossSell2, sidebarBanner.nextSibling);
        } else if (cartFormDiv && cartFormDiv.nextSibling) {
          sidebarBody.insertBefore(crossSell2, cartFormDiv.nextSibling);
        } else if (cartFormDiv) {
          sidebarBody.appendChild(crossSell2);
        } else {
          sidebarBody.insertBefore(crossSell2, sidebarBody.firstChild);
        }
        attachCrossSellListeners(crossSell2);
        reorderSidebarShipping(sidebarBody);
      }
    }
  }

  // --- PDP cross-sell (grouped by step) ---

  function renderPDPCrossSell(data) {
    var existing = document.querySelectorAll('.step-pdp-cross-sell');
    for (var i = 0; i < existing.length; i++) existing[i].remove();

    var buyButtons = document.querySelector('.product-actions');
    if (!buyButtons) return;

    var currentSteps = getCurrentProductSteps();
    if (currentSteps.length === 0) return;

    var uniqueSteps = getUniqueSteps(data);
    var crossSellData = getCrossSellData();
    if (!crossSellData) return;

    var cartProductIds = getCartProductIds(data);
    var currentProductId = getCurrentProductId();

    // Steps that complement the current product (not covered by this product, not in cart)
    var complementSteps = [];
    for (var s = 1; s <= 4; s++) {
      var sStr = String(s);
      if (currentSteps.indexOf(sStr) === -1 && !uniqueSteps[sStr]) {
        complementSteps.push(sStr);
      }
    }
    if (complementSteps.length === 0) return;

    // Build grouped sections — one per missing step
    var groupsHTML = '';
    var hasAny = false;
    for (var g = 0; g < complementSteps.length; g++) {
      var step = complementSteps[g];
      var stepProducts = getFilteredProducts(crossSellData, step, cartProductIds, currentProductId, 2);
      if (stepProducts.length === 0) continue;
      hasAny = true;

      groupsHTML += '<div class="step-cross-sell__group">' +
        '<p class="step-cross-sell__group-label">Step ' + step + '</p>' +
        '<div class="step-cross-sell__list">';
      for (var p = 0; p < stepProducts.length; p++) {
        groupsHTML += buildPDPCardHTML(stepProducts[p]);
      }
      groupsHTML += '</div>';

      // "See all" link if the collection likely has more products
      var allProducts = crossSellData[step];
      var availableCount = allProducts ? allProducts.length : 0;
      if (availableCount > stepProducts.length) {
        groupsHTML += '<a href="/collections/step-' + step + '-products" class="step-cross-sell__see-all">See all Step ' + step + ' products &rarr;</a>';
      }

      groupsHTML += '</div>';
    }

    if (!hasAny) return;

    var html = '<div class="step-cross-sell step-pdp-cross-sell">' +
      '<p class="step-cross-sell__heading">Boost your protection.</p>' +
      '<p class="step-cross-sell__subheading">Each product works on its own – even better together. ' +
        '<a href="/pages/incognito-simple-step-system" class="step-cross-sell__info-link">Find out more &rarr;</a>' +
      '</p>' +
      groupsHTML +
    '</div>';

    var container = document.createElement('div');
    container.innerHTML = html;
    var crossSell = container.firstChild;
    buyButtons.parentNode.insertBefore(crossSell, buyButtons.nextSibling);
    attachCrossSellListeners(crossSell);
  }

  function interceptCheckout(tier) {
    var buttons = document.querySelectorAll(
      'button[name="checkout"], input[name="checkout"], [href*="/checkout"]'
    );

    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].dataset.stepBundleBound) continue;
      buttons[i].dataset.stepBundleBound = 'true';

      buttons[i].addEventListener('click', function (e) {
        if (window.__stepBundleApplying) return;

        e.preventDefault();
        e.stopPropagation();

        var btn = this;
        btn.disabled = true;
        btn.textContent = 'Applying discount...';
        window.__stepBundleApplying = true;

        var data = getStepData();
        var cartLines = [];
        if (data && data.items) {
          for (var j = 0; j < data.items.length; j++) {
            cartLines.push({ product_id: data.items[j].product_id });
          }
        }

        fetch(WORKER_URL + '/api/discount', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ cart_lines: cartLines }),
        })
          .then(function (resp) { return resp.json(); })
          .then(function (result) {
            if (result.code) {
              saveAppliedCode(result.code, result.tier);
              window.location.href = '/discount/' + result.code + '?redirect=/checkout';
            } else {
              window.location.href = '/checkout';
            }
          })
          .catch(function () {
            window.location.href = '/checkout';
          });
      });
    }
  }

  // --- Init ---

  function init() {
    var data = getStepData();
    var tier = computeTier(data);

    clearStaleDiscount(tier);

    renderUI(data, tier);
    if (tier) {
      interceptCheckout(tier);
    }

    renderNudgeStrip(data);
    renderCartCrossSell(data);
    renderPDPCrossSell(data);
    renderSavingsLine(data, tier);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Cart page: listen for cart-updated on the cart-form element
  // and re-fetch section data since step-bundle-data is outside AjaxCartForm
  function setupCartPageListener() {
    var cartFormEl = document.querySelector('cart-form');
    if (!cartFormEl || !isCartPage()) return;

    cartFormEl.addEventListener('cart-updated', function () {
      setTimeout(function () {
        fetch(window.location.pathname + '?section_id=main-cart')
          .then(function (resp) { return resp.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newData = doc.getElementById('step-bundle-data');
            var existing = document.getElementById('step-bundle-data');
            if (newData && existing) {
              existing.textContent = newData.textContent;
            } else if (!newData && existing) {
              existing.textContent = '{"items":[]}';
            }
            init();
          })
          .catch(function () {});
      }, 500);
    });
  }

  // Drawer: watch AjaxCartForm for content changes
  function setupDrawerObserver() {
    if (isCartPage()) return;

    var cartFormEl = document.getElementById('AjaxCartForm');
    if (!cartFormEl) return;

    new MutationObserver(function () {
      init();
    }).observe(cartFormEl, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupCartPageListener();
      setupDrawerObserver();
    });
  } else {
    setupCartPageListener();
    setupDrawerObserver();
  }
})();
